/** QuickPlan — Champ numérique : saisie libre, validée à Entrée ou en quittant le champ
 *  (un seul cran d'historique par saisie), Échap annule. Accepte la virgule décimale. */
import { useState, useEffect } from 'react';

export default function NumField({ value, onCommit, allowNull = false, ...props }) {
  const [text, setText] = useState(value ?? '');
  useEffect(() => { setText(value ?? ''); }, [value]);

  const commit = () => {
    const raw = String(text).trim().replace(',', '.');
    if (raw === '') {
      if (allowNull) onCommit(null);
      else setText(value ?? '');
      return;
    }
    const v = Number(raw);
    if (Number.isNaN(v)) { setText(value ?? ''); return; }
    if (v !== value) onCommit(v);
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.target.blur();
        if (e.key === 'Escape') { setText(value ?? ''); e.target.blur(); }
        e.stopPropagation(); // pas de raccourci clavier global pendant la saisie
      }}
      {...props}
    />
  );
}
